const trimDecimal = (value) => Number(value).toFixed(1).replace(/\.0$/, "");

export const formatCompactIndian = (value, { currency = false } = {}) => {
  const numeric = Number(value) || 0;
  const absValue = Math.abs(numeric);
  let formatted = "0";

  if (absValue >= 10000000) {
    formatted = `${trimDecimal(numeric / 10000000)} Cr`;
  } else if (absValue >= 100000) {
    formatted = `${trimDecimal(numeric / 100000)} Lakh`;
  } else if (absValue >= 1000) {
    formatted = `${trimDecimal(numeric / 1000)}K`;
  } else {
    formatted = numeric.toLocaleString("en-IN");
  }

  return currency ? `\u20B9${formatted}` : formatted;
};
